import { createTRPCProxyClient, httpLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import superjson from 'superjson';
import type { AppRouter } from '../../../api/src/trcp/trpc.router';
import { BASE_API } from '../const/app';
import { useSystemStore } from '../stores/SystemStore';

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
	transformer: superjson as any,

	links: [
		// httpBatchLink({
		httpLink({
			headers() {
				const t = useSystemStore.getState().token;
				if (!t) {
					return {};
				}
				return {
					authorization: t,
				};
			},
			url: `${BASE_API}/trpc`,
			// maxURLLength: MAX_URL_LEN,
		}),
	],
});

export const trcpProxyClient = createTRPCProxyClient<AppRouter>({
	transformer: superjson as any,
	links: [
		// httpBatchLink({
		httpLink({
			headers() {
				const t = useSystemStore.getState().token;
				if (!t) {
					return {};
				}
				return {
					authorization: t,
				};
			},
			url: `${BASE_API}/trpc`,
			// maxURLLength: MAX_URL_LEN,
		}),
	],
});

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;
